module.exports = __webpack_public_path__ + "img/gmsyt2.4bcdf67e.png";